<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M26.51 9.12l-10-6a1 1 0 00-1 0l-10 6A1 1 0 005 10v12a1 1 0 00.49.86l10 6a1 1 0 001 0l10-6A1 1 0 0027 22V10a1 1 0 00-.49-.88zM16 5.16L24.08 10l-3 1.79L13 7zm0 9.67L7.92 10l3.14-1.88L19.14 13zm-9-3.05l8 4.79v9.67l-8-4.79zm10 14.46v-9.67l8-4.79v9.67z"/></svg>